import {
  Directive,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { FeatureName } from '@sc/data-access-models';
import { FeatureFlippingManagerService } from '../../services/feature-flipping-manager';

@Directive({
  selector: '[scFeatureToggle]',
  standalone: true,
})
export class FeatureToggleDirective implements OnInit {
  @Input() public scFeatureToggle: FeatureName[] | FeatureName;

  constructor(
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainer: ViewContainerRef,
    private readonly featureFlippingManager: FeatureFlippingManagerService
  ) {}

  ngOnInit() {
    if (!this.scFeatureToggle) {
      throw new Error(
        'Attribute `scFeatureToggle` should not be null or empty'
      );
    }

    const featureToggleList = Array.isArray(this.scFeatureToggle)
      ? this.scFeatureToggle
      : [this.scFeatureToggle];

    const everyFeatureOk = featureToggleList.every((feature) =>
      this.featureFlippingManager.isFeatureActivated(feature)
    );
    if (everyFeatureOk) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
